class ImageCache {
  constructor() {
    this.cache = new Map();
  }

  cacheImages(imageUrls) {
    imageUrls.forEach(url => {
      this.loadAndCacheImage(url);
    });
  }

  loadAndCacheImage(url) {
    const img = new Image();
    img.onload = () => {
      this.convertToBase64(img, url);
    };
    img.src = url;
  }

  convertToBase64(img, url) {

    // Check if the image is SVG
    if (url.endsWith('.svg')) {

      // Fetch the SVG file
      fetch(url)
        .then(response => response.text())
        .then(svg => {
          const dataURL = 'data:image/svg+xml;base64,' + btoa(svg);
          this.cache.set(url, dataURL); // Save as Base64
        });

    } else {

      // Create a canvas to draw the image
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      // Get the image data URL
      const dataURL = canvas.toDataURL();
      const sizeInKb = Math.round((dataURL.length * (3 / 4)) / 1024); // approximate size in KB

      if (sizeInKb < 10) {
        this.cache.set(url, dataURL); // Save as Base64
      } else {
        this.cache.set(url, url); // Save the URL itself
      }
    }

  }

  getImageSrc(url) {
    return this.cache.get(url) || url; // Return Base64 if available, otherwise URL
  }
}

export default ImageCache;
